var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 7.34177C18.6095 6.95124 17.9763 6.95124 17.5858 7.34177L10.3407 14.5869C9.95016 14.9774 9.31699 14.9774 8.92647 14.5869L6.38507 12.0455C5.99454 11.6549 5.36138 11.6549 4.97085 12.0455C4.58033 12.436 4.58033 13.0692 4.97085 13.4597L7.51774 15.9999C8.68969 17.1687 10.5869 17.1676 11.7574 15.9973L19 8.75598C19.3905 8.36545 19.3905 7.73229 19 7.34177Z",
    fill: "#04C58B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkSmall);
export default __webpack_public_path__ + "static/media/checkmark-small.3fb2019af77f3eb16e225d4e229576e3.svg";
export { ForwardRef as ReactComponent };